import { lazy } from 'react'

export const LibraryPage = lazy(() => import('./LibraryPage'))
